import { AppAction } from '../app';

export const FETCH_SALESTEAM_ROLE_LIST = 'FETCH_SALESTEAM_ROLE_LIST';

export const fetchSalesTeamRoleList = (): AppAction => ({
  type: FETCH_SALESTEAM_ROLE_LIST,
});
